import Intro, { PATH as INTRO } from './Intro'
import Medicine, { PATH as MEDICINE } from './Medicine'

export default { Intro, Medicine }
export const PATH = { INTRO, MEDICINE }
